/*global Event, Element, HTMLDocument*/

String.prototype.trim = String.prototype.trim || function () {

    'use strict';

    return this.
        replace(/^\s+/, '').
        replace(/\s+$/, '');
};

// https://developer.mozilla.org/en-US/docs/Web/API/EventTarget.addEventListener
(function () {
    'use strict';

    if (!Event.prototype.preventDefault) {
        Event.prototype.preventDefault = function () {
            this.returnValue = false;
        };
    }
    if (!Event.prototype.stopPropagation) {
        Event.prototype.stopPropagation = function () {
            this.cancelBubble = true;
        };
    }
    if (!Element.prototype.addEventListener) {
        var eventListeners = [];

        var addEventListener = function (type, listener /*, useCapture (will be ignored) */) {
            var self = this;
            var wrapper = function (e) {
                e.target = e.srcElement;
                e.currentTarget = self;
                if (listener.handleEvent) {
                    listener.handleEvent(e);
                } else {
                    listener.call(self,e);
                }
            };
            if (type === 'DOMContentLoaded') {
                var wrapper2 = function (e) {
                    if (document.readyState === 'complete') {
                        wrapper(e);
                    }
                };
                document.attachEvent('onreadystatechange',wrapper2);
                eventListeners.push({
                    object: this,
                    type: type,
                    listener: listener,
                    wrapper: wrapper2
                });

                if (document.readyState === 'complete') {
                    var e = new Event();
                    e.srcElement = window;
                    wrapper2(e);
                }
            } else {
                this.attachEvent('on' + type, wrapper);
                eventListeners.push({
                    object: this,
                    type: type,
                    listener: listener,
                    wrapper: wrapper
                });
            }
        };
        var removeEventListener = function (type, listener /*, useCapture (will be ignored) */) {
            var counter = 0;
            while (counter < eventListeners.length) {
                var eventListener = eventListeners[counter];
                if (eventListener.object === this && eventListener.type === type && eventListener.listener === listener) {
                    if (type === 'DOMContentLoaded') {
                        this.detachEvent('onreadystatechange', eventListener.wrapper);
                    } else {
                        this.detachEvent('on' + type, eventListener.wrapper);
                    }
                    break;
                }
                counter += 1;
            }
        };
        Element.prototype.addEventListener = addEventListener;
        Element.prototype.removeEventListener = removeEventListener;
        if (HTMLDocument) {
            HTMLDocument.prototype.addEventListener = addEventListener;
            HTMLDocument.prototype.removeEventListener = removeEventListener;
        }
    }
})();

if (typeof Array.prototype.reduce !== 'function') {
    Array.prototype.reduce = function(callback) {
        'use strict';
        if (typeof callback !== 'function') {
            throw new TypeError('reduce called without callback');
        }
        var t = Object(this), k = 0, value;
        if (arguments.length >= 2) {
            value = arguments[1];
        } else {
            while (k < this.length && !(k in t)) { k++; }
            if (k >= this.length) {
                throw new TypeError('Reduce of empty array with no initial value');
            }
            value = t[k++];
        }
        for (; k < this.length ; k++) {
            if (k in t) {
                value = callback(value, t[k], k, t);
            }
        }
        return value;
    };
}

if (!Array.prototype.filter) {
    Array.prototype.filter = function(fun/*, thisArg */) {
        'use strict';

        if (typeof fun !== 'function') {
            throw new TypeError('filter called without callback');
        }

        var res = [];
        var thisArg = arguments.length >= 2 ? arguments[1] : null;
        for (var i = 0; i < this.length; i++) {
            if (i in this) {
                var val = this[i];
                if (fun.call(thisArg, val, i, this)) {
                    res.push(val);
                }
            }
        }

        return res;
    };
}

if (!Array.prototype.forEach) {
    Array.prototype.forEach = function(fun/*, thisArg */) {
        'use strict';

        if (typeof fun !== 'function') {
            throw new TypeError('forEach called without callback');
        }

        var thisArg = arguments.length >= 2 ? arguments[1] : null;
        for (var i = 0; i < this.length; i++) {
            if (i in this) {
                fun.call(thisArg, this[i], i, this);
            }
        }
    };
}

if (!Array.prototype.map) {
    Array.prototype.map = function(fun/*, thisArg */) {
        'use strict';

        if (typeof fun !== 'function') {
            throw new TypeError('map called without callback');
        }

        var res = new Array(this.length);
        var thisArg = arguments.length >= 2 ? arguments[1] : null;
        for (var i = 0; i < this.length; i++) {
            if (i in this) {
                res[i] = fun.call(thisArg, this[i], i, this);
            }
        }

        return res;
    };
}

if(!Array.isArray) {
    Array.isArray = function(arg) {
        'use strict';
        return Object.prototype.toString.call(arg) === '[object Array]';
    };
}
